declare module '#app' {
  // @ts-expect-error For some reason that might throw an error, though it's valid according to the docs
  interface NuxtApp {
    $internalPublicApi: typeof $fetch
  }
}

export default defineNuxtPlugin(() => {
  const { app } = useRuntimeConfig()
  const internalPublicApi = $fetch.create({
    baseURL: `${app.baseURL}/api/intern/public`,
  })
  return {
    provide: {
      internalPublicApi,
    },
  }
})
